<template>
  <div class="conversion-form">
    <div class="conversion-form-item">
      <component 
        ref="component"
        :is="componentName"
        @formchange="handleFormchange"
        :formData="formData"
        :way.sync="way"
        :wayList="wayList"
        :targetList="targets"
        @updateForm="handleUpdateForm"
        :dTarget="target"
        :validNumber="handleValidNumber"
        :conversionPriceData="getConversionPriceData"
        :addType="addType"
        :avgData.sync="avgData"
      />
    </div>
    <div class="opt">
     
      <i class="el-icon-document-copy" @click="handleCopyClick"></i>
      <i class="el-icon-delete" @click="handleDelClick"></i>
      <!-- <span >{{index}}</span> -->
    </div>
  </div>
</template>

<script>
import conversionFormConv from './conversionFormConv.vue'
import conversionFormOther from './conversionFormOther.vue'
import API from '@/api/marketManage/miBatch'
import { numStrip } from '@/utils'
export default {
  components: { },
  props: ['formData', 'targetList', 'addType', 'index'],
  inject:['getFormParams', 'appList'],
  data() {
    return {
      target: this.formData.target,
      form: { },
      wayList: [],
      way: '',
      avgData: null,//均值
    }
  },
  computed:{
    componentName() {
      return this.target === '转化'? conversionFormConv : conversionFormOther
    },
    targets() {
      const data = this.targetList.reduce((pre, item)=> {
        pre[item.param_name] = item
        return pre;
      }, {})
      return Object.values(data)
    },
  },
  watch: {
    targetList: {
      handler (n) {
        const list = n.map(v=>{
          return v.param_name;
        });
        if (!list.includes('转化')) {
          this.target = list[0]
        };
        this.updateWayData()
      },
      immediate: true
    }
  },
  methods: {
    handleValidNumber(num) {
      const value = num+'';
      if (value.indexOf('.')>-1) {
         const list = value.split('.');
         if (list[1].length>2) {
          return [list[0], list[1].slice(0,2)].join('.')
         }
      }
    },
    updateWayData() {
      const data = this.targetList.reduce((pre, item)=> {
        if (pre[item.param_name]) {
          pre[item.param_name].push(item.config)
        }else {
          pre[item.param_name] = [item.config]
        }
        return pre;
      }, {});
      const arr = data[this.target];
      this.wayList = arr;
      this.way = arr.includes(this.formData.way)? this.formData.way : this.wayList[0];
    },
    handleDelClick() {
      this.$emit('updateFormNum', this.formData.id)
    },
    handleFormchange(value) {
      this.avgData = null;
      this.target = value;
      this.updateWayData()
      this.$nextTick(()=>{
        this.$refs.component.triggerPriceTip()
      })
    },
    // copy
    handleCopyClick() {
      this.$emit('copyFormData', { 
        ...this.form,
        way: this.way
      })
    },
    // 更新
    handleUpdateForm(data) {
      // 等待target赋值后再取
      this.$nextTick(()=>{
        this.form = {
          ...data,
          target: this.target,
          id: this.formData.id
        };
      })
    },
    updateData() {
      const data = Object.keys(this.form).reduce((pre,v)=> {
        pre[v] = ""+this.form[v];
        return pre;
      }, {});
      const nameData = this.$refs.component.nameData;
      const deepNameData = this.$refs.component.deepNameData;
      
      const d = { ...data, way: this.way };
      if (nameData) {
        d.nameData = nameData;
      }
      if (deepNameData) {
        d.deepNameData = deepNameData;
      }
      return d;
    },
    // 获取均价
    async getConversionPriceData(p, cb) {
      const obj = this.targetList.reduce((pre, item)=> {
        pre[item.config] = item.param_id;
        return pre;
      }, {})
      try {
        const { display_type, app_id } = this.getFormParams();
        let ids = [ app_id ];
        if (this.addType === 1) {
          ids = this.appList.map(v=> v.app_id)
        };
        const params = {
          display_type,app_id: ids,
          billing_type: obj[this.way],
          ...p
        };
        // type tracking_type conversion_type
        if (!this.avgData) {
          const { data: d } = await API.getConversionPriceDataList(params);
          this.avgData = d
        }
        const n = this.avgData[`${p.type}_avg`]
        const data =  n? numStrip(p.value - n) +'' : n
        if (!data) {
           cb('--')
          return
        }
        const num = +data;
        if (num>0) {
          cb(`高${num}`)
        }else if(num === 0) {
           cb(`${num}`)
        }else {
          cb(`低${-num}`)
        }
      } catch (error) {
        cb('--')
        this.$message.error(error.info || '系统错误')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.conversion-form {
  display: flex;
  min-height: 170px;
  margin-bottom: 16px;
  &-item {
    flex: 1;
    width: 0;
    height: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 0;
  }
  .opt {
    width: 60px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 16px;
    i {
      display: block;
      margin-left: auto;
      font-size: 18px;
      margin-top: 20px;
      color: red;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
        color: #409EFF;
      }
    }
  }
  &::v-deep .el-input-group__append {
    background: #409EFF;
    color: #fff;
  }
}
</style>